import {
    createFirebaseApp,
    createAuth,
    createFirestore,
    createFunctions,
    createStorage,
} from '@repo/firebase';
import { DATABASES } from '@repo/config/appIdentifiers.js';

const firebase = createFirebaseApp();
const auth = createAuth(firebase);
const contentDb = createFirestore(firebase, { databaseId: DATABASES.CONTENT });
const { functions, callable, functionsCustomDomain } = createFunctions(
    firebase,
    {
        customDomain: import.meta.env.VITE_CLOUD_FUNCTION_URL || undefined,
    }
);
// Storage: the TAP redeem journey resolves book-cover thumbnails for the
// unlock preview through @repo/config/Storage, which reads this binding.
const storage = createStorage(firebase);

export {
    firebase,
    auth,
    contentDb,
    functions,
    callable,
    functionsCustomDomain,
    storage,
};
